import { useQuery } from "@tanstack/react-query";
import { Avatar, Spin } from "antd";
import { env } from "@/shared/config";
import { fallbackString } from "@/shared/utils";
import { userServiceApi } from "@shared/api";
import "./user-bubble.scss";

export interface BubbleContentProps {
  userId: string;
}

export const BubbleContent = ({ userId }: BubbleContentProps) => {
  const { data, isLoading } = useQuery({
    queryKey: ["user", "contact", userId],
    queryFn: () =>
      userServiceApi
        .get(`/api/v1/users/${userId}/contacts`)
        .then((response) => response.data),
    enabled: Boolean(userId),
  });

  if (isLoading) {
    return (
      <div className="user-info-dropdown-loading">
        <Spin />
      </div>
    );
  }

  if (!data || data === undefined) {
    return <div>Не удалось найти пользователя / совершить запрос</div>;
  }

  return (
    <div className="user-info-dropdown">
      <Avatar
        className="user-info-avatar"
        src={`${env.OLD_FRONTEND_URL}/api/v1/users/${data.userId}/avatar`}
      />
      <div className="user-info-details">
        <div className="user-info-name">
          {fallbackString(
            `${data.userSurname} ${data.userFirstName} ${data.userMiddleName}`,
          )}
        </div>
        <div className="user-info-organization">
          {fallbackString(data.userCompanies?.[0]?.shortName)}
        </div>
        <div className="user-info-role">
          {fallbackString(data.userCompanies?.[0]?.position)}
        </div>
        <div className="user-info-email">
          <a href={`mailto:${data.userEmail}`} className="user-info-email-link">
            {fallbackString(data.userEmail)}
          </a>
        </div>
        <div className="user-info-phone">{data.userMobilePhone}</div>
      </div>
    </div>
  );
};
